import { MicrotaskType } from 'ihub/common';
import { MicroTaskTourId } from './shared-types';

export const getMicroTaskAdvancedTour = (taskType: MicrotaskType): MicroTaskTourId | undefined => {
	switch (taskType) {
		case MicrotaskType.SetVariable:
			return 'setVariableTask';
		case MicrotaskType.ArrayComparison:
			return 'arrayComparison';
		case MicrotaskType.ArrayToRecords:
			return 'arrayToRecords';
		case MicrotaskType.Batching:
			return 'batching';
		case MicrotaskType.ClearData:
			return 'clearData';
		case MicrotaskType.CustomLog:
			return 'customLog';
		case MicrotaskType.DatabaseConnector:
			return 'databaseConnector';
		case MicrotaskType.Delay:
			return 'delay';
		case MicrotaskType.DuplicateValueCheck:
			return 'duplicateCheck';
		case MicrotaskType.ExecuteFlow:
			return 'executeFlow';
		case MicrotaskType.GetVariable:
			return 'getVariable';
		case MicrotaskType.GoogleSheetsQuery:
			return 'googleSheets';
		case MicrotaskType.HubspotDeleteObjects:
			return 'hubspotDeleteObject';
		case MicrotaskType.Loop:
			return 'loop';
		case MicrotaskType.ParallelJoin:
			return 'parallelJoin';
		case MicrotaskType.ParallelSplit:
			return 'parallelSplit';
		case MicrotaskType.RateLimiter:
			return 'rateLimit';
		case MicrotaskType.RestApiReceiver:
			return 'restApiReceiver';
		case MicrotaskType.S3Reader:
			return 's3Reader';
		case MicrotaskType.S3Writer:
			return 's3Writer';
		case MicrotaskType.SalesforceGetObjects:
			return 'salesforceGetObject';
		case MicrotaskType.DataMapper:
			return 'dataMapper';
		case MicrotaskType.HubspotGetObjects:
		case MicrotaskType.HubspotGetAssociations:
			return 'hubspotGetObjects';
		case MicrotaskType.HubspotSaveAssociations:
			return 'hubspotSaveAssociation';
		case MicrotaskType.HubspotSaveObjects:
			return 'hubspotSaveObjects';
		case MicrotaskType.HubspotWebhook:
			return 'hubspotWebhook';
		case MicrotaskType.IfGate:
			return 'ifGate';
		case MicrotaskType.MergeData:
			return 'mergeData';
		case MicrotaskType.Notification:
			return 'notification';
		case MicrotaskType.RestApiSender:
			return 'restApiSender';
		case MicrotaskType.SalesforceSaveObjects:
			return 'salesforceSaveObjects';
		case MicrotaskType.ScheduleTask:
			return 'scheduleTask';
		case MicrotaskType.ScriptBlock:
			return 'scriptBlock';
		case MicrotaskType.SFTPReader:
			return 'sftpReader';
		case MicrotaskType.SFTPWriter:
			return 'sftpWriter';
		case MicrotaskType.TakeFromArray:
			return 'takeFromArray';
		case MicrotaskType.Validation:
			return 'validation';
		case MicrotaskType.XeroCreateInvoice:
			return 'xeroCreateInvoice';
		case MicrotaskType.AddItem:
			return 'addItem';
		default:
			return;
	}
};
